/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.service('MainService', ["$rootScope", "$http", function ($rootScope, $http) {

        var email = "-1"
        var dialogData = {}
        var eventData = {}
        var profilePic = "-1"
        
        var setDialogData = function (dialogId, data)
        {
            dialogData[dialogId] = data;
        }

        var getDialogData = function (dialogId)
        {
            data = dialogData[dialogId]
            return data;
        }

        var setEmail = function (newemail)
        {
            email = newemail;
        }

        var setEventData = function (data)
        {
            eventData = data
        }
        
        var getEventData = function ()
        {
            return eventData
        }
        var getEmail = function () {
            return email;

        };

        var setProfilePic = function(pic)
        {
            profilePic = pic
        }
        
        var getProfilePic = function(pic)
        {
            return profilePic
        }
        
        return {
            setEmail: setEmail,
            getEmail: getEmail,
            setDialogData: setDialogData,
            getDialogData: getDialogData,
            getEventData: getEventData,
            setEventData: setEventData,
            setProfilePic: setProfilePic,
            getProfilePic: getProfilePic
        };

    }]);